
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    components: {},
})

export default class Notification extends Vue {

    @Prop({default: null})
    private currentUser: any;
    @Prop({default: null})
    private relay: any;

    private notifications = {
       // addGestionaire: true,
        withdraw: true,
        drop: true,
    };
    private savedNotifications = {
       // addGestionaire: true,
        withdraw: true,
        drop: true,
    };
    private displaySaveButton: boolean = false;

    public created(): void {
        this.getInfoNotification();
    }

    private verifyModification(): void {
        this.displaySaveButton = JSON.stringify(this.notifications) !== JSON.stringify(this.savedNotifications);
    }

    private async getInfoNotification(): Promise<void> {
        return await this.$store.dispatch("users/getInfoNotification", {
            id: this.currentUser.id,
            relayId: this.relay.id,
        }).then((data) => {
            this.notifications = Object.assign(this.notifications, data?.notifications);
            this.savedNotifications = Object.assign({}, this.notifications);
        });
    }

    private async saveInfoNotification(): Promise<void> {
        return await this.$store.dispatch("users/saveInfoNotification", {
            notification: this.notifications,
            id: this.currentUser.id,
            relayId: this.relay.id,
        }).then(() => {
            this.getInfoNotification();
            this.displaySaveButton = false;
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_courrier",
                msg: this.$i18n?.t("notification.valide"),
            });
        });
    }
}
